import { useEffect } from "react";
import { connect } from "react-redux";
import { getOrders } from "./redux/actions";
import { cyrb53 } from "./tools/cybr54";

function Startup(props) {
  // On startup, perform the following actions
  useEffect(() => {
    if (
      String(localStorage.getItem("secret")) ===
      String(cyrb53(process.env.REACT_APP_SECRET))
    ) {
      props.getOrders();
    }
  });
  return props.children;
}

export default connect(null, { getOrders })(Startup);



// WEBPACK FOOTER //
// ./src/Startup.js